const PGAdapter = require('../../common/pg-adapter')

const LOCATION_SERVICE_CONTACT_TABLE_NAME = 'avocado.data_location_service_contact'
const LOCATION_SERVICE_CONTACT_COLUMNS = [
  'location_service_id',
  'email',
  'phone',
  'name',
  'created_at',
  'updated_at'
]

class LocationServiceContactPgAdapter extends PGAdapter {
  constructor ({pgConnection, logger, username}) {
    super(pgConnection,
      LOCATION_SERVICE_CONTACT_TABLE_NAME,
      username,
      LOCATION_SERVICE_CONTACT_COLUMNS,
      'location_service_id',
      {},
      logger
    )
  }

  async upsert (locationServiceId, locationServiceContactData) {
    const castEmptyStringsToNull = (value) => {
      if (value === null || value === undefined || value === '' || value.trim().length === 0) {
        return null
      }
      return value
    }

    const locationServiceContact = {
      location_service_id: locationServiceId,
      email: castEmptyStringsToNull(locationServiceContactData.email),
      phone: castEmptyStringsToNull(locationServiceContactData.phone),
      name: castEmptyStringsToNull(locationServiceContactData.name),
      created_at: locationServiceContactData.created_at,
      updated_at: new Date()
    }
    return super.upsert(locationServiceContact, { conflictIdColumns: ['location_service_id'] })
  }
}

module.exports = LocationServiceContactPgAdapter
